import { IGroup } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface JoinGroupState {
  join_code: { [key: string]: IGroup };
}

const initialState: JoinGroupState = {
  join_code: {},
};

const joinGroupSlice = initReducer({
  name: "join-group",
  initialState,
  reducers: {
    setJoinGroup: (state: JoinGroupState, action: PayloadAction<IGroup>) => {
      const group = action.payload;
      if (group.join_code) {
        state.join_code[group.join_code] = group;
      }
    },
    cleanState: () => initialState,
  },
});

const persistConfig: PersistConfig<JoinGroupState> = {
  key: "join-group",
  storage: AsyncStorage,
};

export const joinGroupActions = joinGroupSlice.actions;

export default createPersistReducer(persistConfig, joinGroupSlice.reducer);
